import { call, put } from "redux-saga/effects";
import { push } from "connected-react-router";
import { Creators as SubscriptionCreators } from "../ducks/subscription";
import { Creators as MessagesCreators } from "../ducks/messages";
import api from "../../services/api";

export function* getSubscription() {
  const response = yield call(api.get, "v2/subscriptions");
  if (response.ok) {
    yield put(SubscriptionCreators.getSubscriptionSuccess(response.data));
    if (response.data.via === "mobile") {
      const responseMobile = yield call(api.get, "v2/subscriptions/mobile");
      if (responseMobile.ok) {
        yield put(
          SubscriptionCreators.getSubscriptionMobileSuccess(responseMobile.data)
        );
      } else {
        yield put(SubscriptionCreators.getSubscriptionMobileSuccess({}));
      }
    }
  } else {
    yield put(SubscriptionCreators.getSubscriptionSuccess({}));
  }
}

export function* cancelSubscription() {
  const response = yield call(api.delete, "v2/subscriptions");
  if (response.ok) {
    yield put(SubscriptionCreators.getSubscriptionRequest());
  } else {
    yield put(
      MessagesCreators.setMessage(
        "Ocorreu um erro ao tentar cancelar a assinatura.",
        "danger",
        true
      )
    );
  }
}

export function* getSubscriptionMobile() {
  const response = yield call(api.get, "v2/subscriptions/mobile");
  if (response.ok) {
    yield put(SubscriptionCreators.getSubscriptionMobileSuccess(response.data));
  } else {
    yield put(SubscriptionCreators.getSubscriptionMobileSuccess({}));
  }
}

export function* getPayments() {
  const response = yield call(api.get, "v2/subscriptions/payments");
  if (response.ok) {
    yield put(SubscriptionCreators.getPaymentsSuccess(response.data));
  }
}

export function* applyVoucher(params) {
  const response = yield call(api.post, "v2/vouchers/apply", {
    code: params.code
  });
  if (response.ok) {
    yield put(SubscriptionCreators.getSubscriptionRequest());
    yield put(SubscriptionCreators.getVouchersRequest());
    yield put(
      MessagesCreators.setMessage(
        "Voucher aplicado com sucesso.",
        "success",
        true
      )
    );
    yield put(push("/admin/vouchers"));
  } else {
    yield put(MessagesCreators.setMessage(response.data, "danger"));
  }
}

export function* getVouchers() {
  const response = yield call(api.get, "v2/vouchers");
  if (response.ok) {
    yield put(SubscriptionCreators.getVouchersSuccess(response.data));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/subscription.js